export const environment = {
  production: false,
  APP_NAME: 'Soctrip banner',
  COMPANY_NAME: 'TMA Technology Group',
  TOKEN: 'token_admin',
  AUTH_STATUS: 'auth_status',
  USER_PROFILE: 'user_profile_admin',
  baseURL: 'https://admin-gateway-dev.tma-swerp.com',
  TOKEN_KEY: 'accessToken',
  REFRESH_TOKEN_KEY: 'refresh_token',
  USER_ROLE_KEY: 'user_role',
  REFRESH_TOKEN_EXPIRY_KEY: 'refresh_token_expiry_date',
  ACCESS_TOKEN_EXPIRY_KEY: 'access_token_expiry_date',
  BE_API_URL: 'https://api-dev-tmtrav.tma-swerp.com',
  ADMIN_APP_URL: 'https://admin-dev.tma-swerp.com',
  TRAVEL_ASSIST_URL: 'https://tmtrav-travel-dev.tma-swerp.com',
  BOOKING_URL: 'https://tmtrav-booking-dev.tma-swerp.com',
  ECOMMERCE_FOOD_URL: 'https://tmtrav-food-dev.tma-swerp.com',
  ECOMMERCE_URL: 'https://tmtrav-ecommerce-dev.tma-swerp.com',
  CARRENTAL_URL: 'https://tmtrav-car-rental-dev.tma-swerp.com',
  FLIGHT_URL: 'https://tmtrav-flight-dev.tma-swerp.com',
  ADMIN_HUB_URL: 'https://admin-dev.tma-swerp.com',
  API_TIMEOUT: 10000,
  socialAuthenIds: {
    google: '802332645501-0aiir74m36114t6v974bcrg4jrf8k1do.apps.googleusercontent.com',
    facebook: '2619489051654463',
  },
};
